<template>
      <div class="home">

          <div  id="hero" class="hero">
             <div class="text">

                <h1 class="">"Rast nikad nije slučajan</h1>
                <h1>on je ishod snaga koje rade zajedno"</h1>
                <h1><span> -- Džejms Keš Peni </span> </h1>

             </div>
             <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FVirginia-doo-Beograd-613580285346651%2F&amp;tabs=timeline&amp;width=300&amp;height=600&amp;small_header=false&amp;adapt_container_width=true&amp;hide_cover=false&amp;show_facepile=true&amp;appId=141093469313391"
             width="300" height="500" style="border:none;overflow:hidden" scrolling="yes" frameborder="0" allowtransparency="true" allow="encrypted-media" class="fb_iframe_widget velika">
             </iframe>
             <div class="wrapper">
               <!-- <div class="brands"  >
                 <div class="linija">
                   <div class="brand" v-for="bra in brand">
                     <img :src="brandurl + bra.bra_id" alt="">
                   </div>
                 </div>

             </div> -->
             </div>
          </div>

          <div class="wrapper">
            <div class="main">
              <h2>Tamo gde uspeh počinje ... </h2>
              <div class="container" >
                  <div class="card" v-for="kat in kategorije" @click="discover(kat.kat_naziv)" title="Klikni i pretraži">
                    <h3 class="title">{{kat.kat_naziv}}</h3>
                    <div class="bar">
                      <div class="emptybar"></div>
                      <div class="filledbar"></div>
                    </div>
                    <div class="circle">
                      <img :src="katurl+kat.kat_id"  alt=""  >
                    </div>
                  </div>
              </div>
            </div>

          </div>
          <div class="donjaslika">
            <h2>ŠTA NUDIMO ?</h2>
            <div class="wrapper" >

              <table v-for="kat in kategorije">
                <tr>
                  <th > {{kat.kat_naziv}} </th>
                </tr>
                <br>
                <tr  v-for="pod in podkategorije"  v-show="pod.kat_id == kat.kat_id" @click="discover1(kat.kat_naziv,pod.pod_naziv)">
                  <td > {{pod.pod_naziv}}</td>
                </tr>
              </table>

            </div>
            <!-- <div class="saznaj">
              <span @mouseover="strelica1 = true" @mouseleave = "strelica1 = false">Saznaj vise </span><span v-if="strelica1">>></span>
            </div> -->
      </div>

        <div class="wrapper">
          <div class="testiranja">
          <h2>NAJNOVIJA TESTIRANJA !</h2>
          <p>U cilju potvrde kvaliteta naših proizvoda, redovno vršimo testiranja na našim oglednim poljima.</p>

          <div class="container" style="min-height:400px;" v-if="gettestiranja">
              <div class="card" title="Klikni i pretraži" v-for="(test,index) in 3" @click="discovertest(gettestiranja[0].test_naslov)">
                <h3 class="title">{{gettestiranja[0].test_naslov}}, 2020</h3>
                <div class="bar">
                  <div class="emptybar"></div>
                  <div class="filledbar"></div>
                </div>
                <div class="circle">
                  <img :src="podkaturl+gettestiranja[0].pod_id"  alt=""  >
                </div>
              </div>


          </div>

          <div class="saznaj">
            <span @click="discovertestiranja()" @mouseover="strelica = true" @mouseleave = "strelica = false">Saznaj vise </span><span v-if="strelica">>></span>
          </div>
        </div>

      </div>
      </div>


</template>

<script>

import {mapGetters, mapActions, mapMutations} from 'vuex'


export default {

  data () {
    return {
        strelica1:false,
        strelica:false,
        min:0,
        max:3
    }
  },
  created(){

    this.getproizvodi();
    this.getbrand()
    this.testiranja()
},
computed:{
          ...mapGetters([
            'kategorije',
            'podkategorije',
            'singlpk',
            'brandurl',
            'brand',
            'katurl',
            'podkaturl',
            'gettestiranja'



          ]),

},
methods:{
  discovertestiranja(){
    this.$router.push("/test/")
  },
  discovertest(naslov){
    this.$router.push("/test/"+naslov)
  },
  discover(kategorija){
    this.$router.push("/proizvodi/"+kategorija)
  },
  discover1(kategorija, podkategorija){

      this.$router.push("/proizvodi/"+kategorija + "/" + podkategorija)

  },
          ...mapMutations([
              'setnaziv',
              'setkat'
          ]),
          ...mapActions([
              'getproizvodi',
              'getsinglpk',
              'getbrand',
              'testiranja'

          ]),

    },

mounted(){

  // document.addEventListener('click', () => {
  // this.setsearch(false)})
    // this.checksession(this.getsid)
    // this.getproducts()


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="">

</style>



// WEBPACK FOOTER //
// src/components/pocetna.vue